import * as React from 'react';

function SvgPartnerDetailEdit(props) {
  return (
    <svg width={18} height={18} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.876 8.998H15.75a.161.161 0 00-.161.16v6.43H2.41V2.408H8.84c.088 0 .16-.071.16-.16V1.123a.161.161 0 00-.16-.16H1.608a.642.642 0 00-.643.642v14.786c0 .356.287.643.643.643h14.785a.642.642 0 00.643-.643V9.159a.161.161 0 00-.16-.16z"
        fill="#38B2A6"
      />
      <path
        d="M5.864 9.458l-.038 2.389a.322.322 0 00.322.325h.008l2.37-.058a.167.167 0 00.109-.046L16.99 3.73a.161.161 0 000-.227l-2.497-2.495a.166.166 0 00-.229 0L5.91 9.346a.167.167 0 00-.047.112zm1.276.474l7.238-7.222.908.906-7.242 7.226-.918.022.014-.932z"
        fill="#38B2A6"
      />
    </svg>
  );
}

export default SvgPartnerDetailEdit;
